import Vue from 'vue';
import * as Sentry from '@sentry/vue';

const SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN;

export default function sentry(router) {
  if (!SENTRY_DSN) {
    return;
  }

  Sentry.init({
    Vue,
    dsn: SENTRY_DSN,
    environment: process.env.VUE_APP_MODE,
    // Sem `release` o requestx devolve os frames do stacktrace sem traduzir -
    // o resolver de source map casa artefato por release. O CI injeta o SHA.
    release: process.env.VUE_APP_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
  });
}
